<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">배너상세</h4>
        </template>

        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">한국어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">영어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileEnUrl" @onChangeFileIds="onFileIdEnChange" />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">일본어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileJaUrl" @onChangeFileIds="onFileIdJaChange" />
              </div>
            </div>
          </div>
        </div>
        <div class="row has-image">
          <label class="col-sm-2 col-form-label">링크</label>
          <div class="col-sm-10">
            <LinkSelect @linkChangeEvent="getLink" class="link-selection" link-model="link" />
            <base-input placeholder="링크" v-model="link">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">노출타입</label>
          <div class="col-sm-10">
            <el-select v-if="bannerId" size="large" class="select-primary" placeholder="선택" v-model="type">
              <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.name" />
            </el-select>
            <el-select v-else size="large" class="select-primary" placeholder="선택" v-model="type" multiple>
              <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.name" />
            </el-select>
          </div>
          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출시작시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출종료시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">배너노출아티스트</label>
          <div class="col-sm-10 checkbox-radios">
            <div class="row">
              <base-button @click="selectAllUnits" type="default">모두선택</base-button
              ><base-button @click="unselectAllUnits" type="default">모두해제</base-button>
            </div>
            <span v-for="(n, index) in units" :key="index">
              <base-checkbox v-model="units[index].value" inline>{{ n.blipName }}</base-checkbox>
            </span>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">팝업노출국가</label>
          <div class="col-sm-10 checkbox-radios">
            <collapse>
              <collapse-item title="팝업노출국가 선택" class="text-left">
                <div class="row">
                  <base-button @click="selectAllCodes" type="default">모두선택</base-button
                  ><base-button @click="unselectAllCodes" type="default">모두해제</base-button>
                </div>
                <span v-for="(n, index) in countryCodes" :key="index">
                  <base-checkbox v-model="countryCodes[index].value" inline>{{ n.name }}</base-checkbox>
                </span>
              </collapse-item>
            </collapse>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
      <base-button v-if="bannerId && state === 1" @click="setBannerState(0)" type="default">숨김</base-button>
      <base-button v-if="bannerId" @click="setBannerState(-1)" type="danger">삭제</base-button>
      <base-button v-if="bannerId && state === 0" @click="setBannerState(1)" type="default">표시</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card, Collapse, CollapseItem } from "@/components/index";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { Toast } from "@/util/Toast";
import LinkSelect from "@/pages/Components/LinkSelect.vue";

export default {
  components: {
    CollapseItem,
    Collapse,
    Card,
    BaseInput,
    LinkSelect,
    BlipFileUploadZone,
  },
  async created() {
    await this.getAllUnits();
    await this.getCountryCodes();
    if (this.$route.query.bannerId) {
      this.bannerId = Number(this.$route.query.bannerId);
      await this.getData();
    }
  },
  data() {
    return {
      bannerId: null,
      title: null,
      description: null,
      imageFileId: null,
      imageFileUrl: null,
      imageFileEnId: null,
      imageFileEnUrl: null,
      imageFileJaId: null,
      imageFileJaUrl: null,
      link: null,
      startTime: null,
      endTime: null,
      units: [],
      type: 0,
      state: 1,
      countryCodes: [],
      types: [
        {
          type: 0,
          name: "메인 중단",
          namespace: 600,
          position: 2,
        },
        {
          type: 1,
          name: "타임라인 중단",
          namespace: 1500,
          position: 2,
        },
        {
          type: 2,
          name: "알림 상단",
          namespace: 20,
          position: 1,
        },
      ],
    };
  },
  methods: {
    selectAllUnits() {
      for (const unit of this.units) {
        unit.value = true;
      }
    },
    unselectAllUnits() {
      for (const unit of this.units) {
        unit.value = false;
      }
    },
    selectAllCodes() {
      for (const countryCode of this.countryCodes) {
        countryCode.value = true;
      }
    },
    unselectAllCodes() {
      for (const countryCode of this.countryCodes) {
        countryCode.value = false;
      }
    },
    async getCountryCodes() {
      return this.$axios.get(`/common/countryCodes`).then((res) => {
        const data = res.data.data;
        this.countryCodes = data.map((d) => {
          d.value = false;
          return d;
        });
      });
    },
    async getAllUnits() {
      return this.$axios.get(`/artistUnit`).then((res) => {
        const data = res.data.data;
        this.units = data.map((d) => {
          d.value = false;
          return d;
        });
      });
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    onFileIdEnChange(newFileIds) {
      this.imageFileEnId = newFileIds[0];
    },
    onFileIdJaChange(newFileIds) {
      this.imageFileJaId = newFileIds[0];
    },

    async getData() {
      return this.$axios.get(`/eventBanner/${this.bannerId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.title = data.title;
          this.description = data.description;
          this.imageFileId = data.imageFileId;
          this.imageFileEnId = data.imageFileEnId;
          this.imageFileJaId = data.imageFileJaId;
          this.link = data.link;
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.state = data.state;
          this.type = this.types.filter((type) => type.namespace === data.namespace && type.position === data.position)[0].type;
          if (this.imageFileId) {
            this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          }
          if (this.imageFileEnId) {
            this.imageFileEnUrl = window.Endpoints.imageServerUrl + this.imageFileEnId;
          }
          if (this.imageFileJaId) {
            this.imageFileJaUrl = window.Endpoints.imageServerUrl + this.imageFileJaId;
          }
          const unitIds = data.unitIds.split(",").map((unitId) => parseInt(unitId, 10));
          this.units.forEach((unit) => {
            for (const unitId of unitIds) {
              if (unit.unitId === unitId) {
                unit.value = true;
              }
            }
          });
          if (data.countryCodes) {
            const countryCodes = data.countryCodes.split(",");
            this.countryCodes.forEach((code) => {
              for (const countryCode of countryCodes) {
                if (countryCode === code.isoCode) {
                  code.value = true;
                }
              }
            });
          }
        }
      });
    },
    async setBannerState(state) {
      return this.$axios
        .put(`/eventBanner/${this.bannerId}/state`, {
          params: { state },
        })
        .then((res) => {
          Toast.success("상태가 변경되었습니다");
          this.state = state;
        });
    },
    getLink(param) {
      const linkModel = param.linkModel.split(".");
      this[linkModel[0]] = param.value;
    },
    async onSubmit() {
      if (!this.imageFileId && !this.imageFileUrl) {
        Toast.error("한국어 이미지는 필수입니다");
        return;
      }
      if (!this.startTime || !this.endTime) {
        Toast.error("시간을 입력해주세요");
        return;
      }

      if (new Date(this.startTime) > new Date(this.endTime)) {
        Toast.error("종료시간이 시작시간보다 빨라요");
        return;
      }

      const units = [];
      this.units.forEach((u) => {
        if (u.value) {
          units.push(u.unitId);
        }
      });
      if (units.length === 0) {
        Toast.error("아티스트를 선택해주세요");
        return;
      }
      const countryCodes = [];
      this.countryCodes.forEach((u) => {
        if (u.value) {
          countryCodes.push(u.isoCode);
        }
      });
      const params = {
        title: null,
        description: null,
        imageFileId: this.imageFileId,
        imageFileEnId: this.imageFileEnId,
        imageFileJaId: this.imageFileJaId,
        link: this.link,
        namespace: null,
        position: null,
        startTime: this.startTime,
        endTime: this.endTime,
        units,
        countryCodes: countryCodes.length > 0 ? countryCodes.toString() : null,
      };

      if (this.bannerId) {
        const type = this.types.filter((type) => type.type === this.type)[0];
        params.namespace = type.namespace;
        params.position = type.position;
        await this.$axios.put(`/eventBanner/${this.bannerId}`, {
          params,
        });
        Toast.success("배너가 수정되었습니다");
      } else {
        for (const t of this.type) {
          const type = this.types.filter((type) => type.type === t)[0];
          params.namespace = type.namespace;
          params.position = type.position;
          await this.$axios.post("/eventBanner", {
            params,
          });
        }
        Toast.success("배너가 등록되었습니다");
      }
      this.goBack();
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.has-image {
  padding-top: 100px;
}
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
